var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcAddIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    filerule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 3.33203C10.4606 3.33203 10.8337 3.70513 10.8337 4.16536V15.832C10.8337 16.2923 10.4606 16.6654 10.0003 16.6654C9.54009 16.6654 9.16699 16.2923 9.16699 15.832V4.16536C9.16699 3.70513 9.54009 3.33203 10.0003 3.33203Z",
    fill: "#707494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    filerule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 10.0013C3.33301 9.54106 3.7061 9.16797 4.16634 9.16797H15.833C16.2932 9.16797 16.6663 9.54106 16.6663 10.0013C16.6663 10.4615 16.2932 10.8346 15.833 10.8346H4.16634C3.7061 10.8346 3.33301 10.4615 3.33301 10.0013Z",
    fill: "#707494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcAddIcon);
export default __webpack_public_path__ + "static/media/ProcAddIcon.da57a5618d406b4825bccf690d0c2313.svg";
export { ForwardRef as ReactComponent };